export default __webpack_public_path__ + "static/media/female.b8297964.png";